import { render } from "./TextWarn.vue?vue&type=template&id=2c4a6e9d&scoped=true"
import script from "./TextWarn.vue?vue&type=script&lang=js"
export * from "./TextWarn.vue?vue&type=script&lang=js"

import "./TextWarn.vue?vue&type=style&index=0&id=2c4a6e9d&scoped=true&lang=css"

import exportComponent from "/var/www/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4a6e9d"]])

export default __exports__